import { render, staticRenderFns } from "./ConfigurazioniMagazzinoArticoliTipoListPage.vue?vue&type=template&id=26796d4b"
import script from "./ConfigurazioniMagazzinoArticoliTipoListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoArticoliTipoListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports